import { render, staticRenderFns } from "./TextColumns.vue?vue&type=template&id=6f16013a&scoped=true"
import script from "./TextColumns.vue?vue&type=script&lang=js"
export * from "./TextColumns.vue?vue&type=script&lang=js"
import style0 from "./TextColumns.vue?vue&type=style&index=0&id=6f16013a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f16013a",
  null
  
)

export default component.exports